module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [(_vm.assignedShpoUser.username) ? _c('span', [_vm._v("\n            Assigned SHPO User: " + _vm._s(((_vm.assignedShpoUser.firstName) + " " + (_vm.assignedShpoUser.lastName))) + " (" + _vm._s(_vm.assignedShpoUser.username) + ")\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isVisible) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "name": "userAssign"
    },
    on: {
      "click": function($event) {
        _vm.$refs['userAssignModal'].open()
      }
    }
  }, [_vm._v("User Assigment")]) : _vm._e()]), _vm._v(" "), _c('modal', {
    ref: "userAssignModal"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left align-bottom"
  }, [_vm._v("User Assignment")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['userAssignModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h5', [_vm._v("Current Assigned User:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('h5', [_vm._v(_vm._s(_vm.assignedUser.username))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('v-client-table', {
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "data": _vm.assignableUserList,
      "columns": _vm.gridSpec.columns,
      "options": _vm.gridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "reassign",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-user",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.reassignUser(props.row)
            }
          }
        })])]
      }
    }])
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "type": "button",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['userAssignModal'].close()
      }
    }
  }, [_vm._v("Close")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-061b1d5f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserAssignment.vue
// module id = 889
// module chunks = 1